//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import PhoneInput from './phone-input';
import parsePhoneNumber from 'libphonenumber-js';
import './phone-input/styles/bootstrap.css';

import * as S from '../../styles';
export interface IPhoneNumberInputProps {
  id: string;
  label?: string;
  value?: string;
  errorText?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  labelColor?: string;
  hasError?: boolean;
  isJamaican?: boolean;
  onCompChange?(id: string, payload: any, errorData: any): void;
}

export const PhoneNumberInput = ({
  id,
  label,
  hasError,
  errorText,
  value,
  required,
  placeholder,
  onCompChange,
  isJamaican,
  numberlimit,
  labelColor,
}: IPhoneNumberInputProps) => {
  const [valid, setValid] = useState<Boolean>(true);
  const [textValue, setTextValue] = useState(value ?? '');
  const [errorData, setErrorData] = useState('');
  const onChange = (id: string, e: any) => {
    const number = `+${e}`;
    setTextValue(number);
    const phoneValid = parsePhoneNumber(number);
    if (phoneValid?.isValid()) {
      if (!valid) {
        setValid(true);
      }
    } else {
      if (valid) {
        setValid(false);
      }
    }
    onCompChange && onCompChange(id, number, errorData);
  };
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (!valid) {
      console.log(errorData);
      if (
        isJamaican &&
        !textValue.startsWith('+1876') &&
        !textValue.startsWith('+1658')
      ) {
        return (
          <S.FeedbackOtherLabel type="tooltip">
            {`Phone Number should be a local Jamaican number.`}
          </S.FeedbackOtherLabel>
        );
      }
      return (
        <S.FeedbackOtherLabel type="tooltip">
          {/* {'Phone number is not valid!'} */}
          {`Phone Number should contain at least ${errorData} numbers`}
        </S.FeedbackOtherLabel>
      );
    }
    if (hasError && errorText) {
      return (
        <S.FeedbackOtherLabel type="tooltip">{errorText}</S.FeedbackOtherLabel>
      );
    }
    return null;
  };
  useEffect(() => {
    console.log(valid, errorData, hasError);
  }, [valid]);
  return (
    <>
      <Form.Group id={id} className="mb-4 formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <PhoneInput
            className="formcontrol shadow-none"
            isValid={valid}
            onChange={onChange.bind(null, id)}
            required={required}
            value={textValue}
            placeholder={placeholder}
            enableSearch={true}
            copyNumbersOnly={false}
            setErrorData={setErrorData}
          />
          <InputGroup>{_renderErrorTextIf()}</InputGroup>
        </InputGroup>
      </Form.Group>
    </>
  );
};

PhoneNumberInput.defaultProps = {
  required: false,
  hasError: false,
  isJamaican: false,
};
